<script lang="ts">
	import { page } from '$app/state';
	import AntonioChat from '#lib/antonio/AntonioChat.svelte';
	import {
		AntonioChatContext,
		setAntonioChatContext
	} from '#src/contexts/antonio-chat.context.svelte.ts';
	import { PbCoreApiService } from '#src/services/pb-core-api.service.svelte.ts';
	import { onMount } from 'svelte';

	interface Props {
		apiKey: string;
		baseUrl?: string;
		model?: string;
		chatPlaceholder?: string;
	}

	let { apiKey, baseUrl = 'https://api.botbakery.app', model, chatPlaceholder }: Props = $props();

	// Context must be constructed and set synchronously here (Svelte requires
	// setContext to run during initial component render) — the instance fetch
	// below is deferred to onMount and backfilled onto page.data.instance.
	const ctx = new AntonioChatContext(baseUrl, apiKey, model);
	setAntonioChatContext(ctx);

	onMount(async () => {
		const pbService = new PbCoreApiService(baseUrl, apiKey);
		page.data.instance = await pbService.getMyInstance();
	});
</script>

{#if page.data.instance}
	<div class="standalone-antonio-chat">
		<AntonioChat {chatPlaceholder} />
	</div>
{/if}

<style lang="scss">
	.standalone-antonio-chat {
		display: flex;
		flex-direction: column;
		height: 100%;
		width: 100%;
		overflow: hidden;
		background: var(--surface-1);
		position: relative;
		color: var(--text-primary);

		--antonio-avatar-size: 120px;
		--antonio-max-text-size: 1.5rem;
	}
</style>
